import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../../app/store";
import {SliceStatus} from "../../../BaseState";
import UserUpdateModalState from "./UserUpdateModalState";

const initialState: UserUpdateModalState = {
  isOpened: false,
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const userUpdateModalSlice = createSlice({
  name: "userUpdateModal",
  initialState,
  reducers: {
    setIsOpened: (draft, action: PayloadAction<boolean>) => {
      draft.isOpened = action.payload;
    }
  }
});

export const userUpdateModalState = (state: RootState): UserUpdateModalState => state.userUpdateModal;
export const {setIsOpened} = userUpdateModalSlice.actions;
export default userUpdateModalSlice.reducer;
